export default __webpack_public_path__ + "static/media/heroImage8.90202f7d.webp";